import { NavLink } from "react-router-dom";

import { useContext, useState, useEffect } from "react";
import UserContext from "../../UserContext";
export default function SidebarNav() {
  const { user, setMode, mode } = useContext(UserContext); // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);
  return (
    <div className="flex items-center h-screen justify-center">
      <div className="w-1/2 cursor-pointer">
        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink exact to="/" activeClassName="mobo-active-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              className="active-icon"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1zM6 19h12V9.157l-6-5.454-6 5.454V19z"
                fill={dark ? "#ffffff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>
        {/* explore */}

        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink
            activeClassName="mobo-active-icon"
            to={!user?.token ? "/login" : "/explore"}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              className="active-icon"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm4.5-12.5L14 14l-6.5 2.5L10 10l6.5-2.5zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                fill={dark ? "#ffffff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>

        {/* messages */}
        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink
            to={!user?.token ? "/login" : "/messages"}
            activeClassName="mobo-active-icon"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M7.291 20.824L2 22l1.176-5.291A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.956 9.956 0 0 1-4.709-1.176zm.29-2.113l.653.35A7.955 7.955 0 0 0 12 20a8 8 0 1 0-8-8c0 1.334.325 2.618.94 3.766l.349.653-.655 2.947 2.947-.655z"
                fill={dark ? "#ffffff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>

        {/* games */}

        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink to="/games" activeClassName="mobo-active-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M17 4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6h10zm0 2H7a4 4 0 0 0-3.995 3.8L3 10v4a4 4 0 0 0 3.8 3.995L7 18h10a4 4 0 0 0 3.995-3.8L21 14v-4a4 4 0 0 0-3.8-3.995L17 6zm-7 3v2h2v2H9.999L10 15H8l-.001-2H6v-2h2V9h2zm8 4v2h-2v-2h2zm-2-4v2h-2V9h2z"
                fill={dark ? "#ffffff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>

        {/* add post */}
        <div className="my-4 flex justify-start">
          <NavLink
            activeClassName="mobo-active-icon"
            to={!user?.token ? "/login" : "/create-post"}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="50"
              height="50"
              className="active-icon"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11H7v2h4v4h2v-4h4v-2h-4V7h-2v4z"
                fill="rgba(249,2,2,1)"
              />
            </svg>
          </NavLink>
        </div>

        {/* settings */}
        {/* <NavLink to="/edit-profile" activeClassName="mobo-active-icon">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" className="active-icon"><path fill="none" d="M0 0h24v24H0z"/><path d="M3.34 17a10.018 10.018 0 0 1-.978-2.326 3 3 0 0 0 .002-5.347A9.99 9.99 0 0 1 4.865 4.99a3 3 0 0 0 4.631-2.674 9.99 9.99 0 0 1 5.007.002 3 3 0 0 0 4.632 2.672c.579.59 1.093 1.261 1.525 2.01.433.749.757 1.53.978 2.326a3 3 0 0 0-.002 5.347 9.99 9.99 0 0 1-2.501 4.337 3 3 0 0 0-4.631 2.674 9.99 9.99 0 0 1-5.007-.002 3 3 0 0 0-4.632-2.672A10.018 10.018 0 0 1 3.34 17zm5.66.196a4.993 4.993 0 0 1 2.25 2.77c.499.047 1 .048 1.499.001A4.993 4.993 0 0 1 15 17.197a4.993 4.993 0 0 1 3.525-.565c.29-.408.54-.843.748-1.298A4.993 4.993 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334a8.126 8.126 0 0 0-.75-1.298A4.993 4.993 0 0 1 15 6.804a4.993 4.993 0 0 1-2.25-2.77c-.499-.047-1-.048-1.499-.001A4.993 4.993 0 0 1 9 6.803a4.993 4.993 0 0 1-3.525.565 7.99 7.99 0 0 0-.748 1.298A4.993 4.993 0 0 1 6 12c0 1.26-.47 2.437-1.273 3.334a8.126 8.126 0 0 0 .75 1.298A4.993 4.993 0 0 1 9 17.196zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>
</NavLink> */}

        {/* lightmode && darkmode */}
        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          {dark ? (
            <span onClick={() => setMode()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-6.671-5.575A8 8 0 1 0 16.425 5.328a8.997 8.997 0 0 1-2.304 8.793 8.997 8.997 0 0 1-8.792 2.304z"
                  fill="rgba(255,255,255,1)"
                />
              </svg>
            </span>
          ) : (
            <span onClick={() => setMode()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-6.671-5.575A8 8 0 1 0 16.425 5.328a8.997 8.997 0 0 1-2.304 8.793 8.997 8.997 0 0 1-8.792 2.304z"
                  fill="#747474"
                />
              </svg>
            </span>
          )}
        </div>

        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink
            activeClassName="mobo-active-icon"
            to={!user?.token ? "/login" : "/edit-profile"}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              className="active-icon"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M4 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"
                fill={dark ? "#ffffff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>

        {/* report issue */}
        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink to="/issues" activeClassName="mobo-active-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M17 17v2a1 1 0 0 0 2 0V4H5v11H3V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16z"
                fill={dark ? "#fff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>

        {/* logout */}

        <div
          className={`"my-4 w-10 h-10 p-4 rounded-full flex items-center justify-center " ${
            dark ? "hover:bg-red-600" : "hover:bg-gray-100"
          }`}
        >
          <NavLink to="/logout" activeClassName="mobo-active-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.985 9.985 0 0 1 8 4h-2.71a8 8 0 1 0 .001 12h2.71A9.985 9.985 0 0 1 12 22zm7-6v-3h-8v-2h8V8l5 4-5 4z"
                fill={dark ? "#fff" : "#747474"}
              />
            </svg>
          </NavLink>
        </div>
      </div>
    </div>
  );
}
